import { useCallback, useContext } from 'react';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { ChatContextType } from '@trinity/chat';
import { HeaderContextContext } from '../context';

type Params = {
  onClick?: () => unknown;
};

export const useSetGlobalChatContext = (params?: Params) => {
  const dispatch = useContext(ChatStateDispatchContext);
  const { setPendingContext, setPendingContextType } = useContext(HeaderContextContext);
  const brandIdentifier = useActiveBrandIdentifier();

  const setGlobalChatContext = () => {
    dispatch({
      type: 'instance-context-changed',
      payload: {
        context: {
          type: ChatContextType.Global,
        },
        brandIdentifier,
      },
    });
    setPendingContextType(null);
    setPendingContext(null);
    params?.onClick?.();
  };

  return useCallback(setGlobalChatContext, [
    brandIdentifier,
    dispatch,
    params,
    setPendingContextType,
    setPendingContext,
  ]);
};